import styled from 'styled-components'
import { devices, tablet } from '../../../../utils/mediaQueries'

// eslint-disable-next-line import/prefer-default-export
export const WrapperProfile = styled.div`
  
  height: 100%;
  overflow-y: scroll;
  position: relative;
  padding: 50px 20px;
  margin: auto;

  ${tablet({
    padding: '0px 20px',
    maxHeight: 'calc(100vh - 135px)',
  })}

  .main-home {
    display: flex;
    flex-direction: column;
  }

  .wizard-container {
    margin: 0 auto;
    display: flex;
    padding: 25px; 
    max-width: 750px;
    flex-direction: column;
    gap: 50px;

    ${tablet({
      width: '100%',
      gap: '5px',
    })}
  }
  
  .buttonRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    height: 50;
    padding-top: 20px;
  }

  .buttonPrevious {
    position: fixed;
    left: 1rem;
    bottom: 1rem;
    z-index: 10000;

    ${tablet({
      position: 'relative',
      left: 'unset',
      bottom: 'unset',
      zIndex: 1,
    })}
  }

  .buttonNext {
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    z-index: 10000;

    ${tablet({
      position: 'relative',
      right: 'unset',
      bottom: 'unset',
      zIndex: 1,
    })}
  }
  
  

  .completion-profile-card {
    display: none !important;
  }

  .base-box {
    min-width: 125px;
    height: fit-content;
    padding: 10px 5px;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;
    cursor: pointer;
  }

  .new-likes {
    background: #2d60de;
    color: white;
  }
  .new-likes-title,
  .new-suggestions-title {
    display: flex;
    align-items: center;
    font-weight: 700;
    font-size: 16px;
  }

  .new-suggestions {
    background: #30dbb4;
    color: white;
  }

  .match-count {
    font-size: 45px;
    font-weight: 900;
    color: #2d60de;
    opacity: 1;
    text-align: center;
  }
  .matching-offers-count {
    color: white;
  }

  .box-link {
    display: flex;
    align-items: center;
    gap: 2px;
    justify-content: flex-end;
    font-weight: 700;
    opacity: 1;
    text-decoration: underline;
    background-color: transparent;
    border: none;
  }

  .wrap-and-gap {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .step-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    margin: auto;
  }

  .first-step {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    gap: 10;
    flex-direction: column;

    & label {
      width: 100%;
    }
  }

  .step-title {
    font-weight: 600;
  }

  .step-sublist {
    padding-left: 8px;
  }

  .footer-wizard {
    display: flex;
    height: 50;
    position: relative;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding-top: 20px;


  @media ${devices.tablet} {
    .main-home {
      flex-direction: row;
    }
    .wizard-container {
      padding: 25px;
      width: 80vw;
      margin: auto;
      margin-top: 0px;
    }
    .first-step {
      flex-direction: row;
      gap: 5px;
    }
    .completion-profile-card {
      display: flex !important;
    }
    .fill-infos-group {
      display: flex;
      flex-direction: column;
      gap: 3px;
    }
  }
`
